import React, { useState } from 'react'

import './sort-goods-group.scss'
import { Group } from '@/model/types/goods'
import { $post } from '@/api'
import { useDynamicList, useRequest } from 'ahooks'
import { Expaned, Column } from '@/components/layout/layout'
import { SortSelectGoodGroupItem } from './sort-goods-group-item'
import { errorCallBack, get } from '@/utils'
import { Spin } from 'antd'
import { sortGoodStore } from '../model'
import useBemClass from '@/utils/hooks/useBEMClass'
import { SortableContainer } from 'react-sortable-hoc'
import { useRef } from 'react'
import $msg from '@/utils/message'

const SortGroupList = SortableContainer(
    (props: { groupArr: Group[]; onClick: (index: number) => void; secondGroupId: number }) => {
        const getCls = useBemClass('sort-goods-group')

        return (
            <Expaned className={getCls('content')}>
                {props.groupArr.map((group, index) => (
                    <SortSelectGoodGroupItem
                        index={index}
                        key={group.id}
                        group={group}
                        groupArr={props.groupArr}
                        groupIndex={index}
                        onClick={(val, index) => {
                            props.onClick(index)
                        }}
                        secondGroupId={props.secondGroupId}
                    />
                ))}
            </Expaned>
        )
    },
)

const SortGoodsGroup = () => {
    const getCls = useBemClass('sort-goods-group')

    const { list: groupArr, resetList, replace, move } = useDynamicList<Group>([])
    const groupIds = useRef<(number | undefined)[]>([])
    const [secondGroupId] = useState<number>(0)

    const sortGroupReq = useRequest(
        () =>
            $post({
                url: '/goods/editgrouppriority',
                params: { group_ids: groupIds.current },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '分组排序成功')
                sortGoodStore.setGroupUpdate()
            },
            onError: errorCallBack,
        },
    )

    const { loading } = useRequest(
        () =>
            $post({
                url: '/goods/getgoodsgroup',
            }),
        {
            onSuccess: async (e: Group[]) => {
                groupIds.current = e.map(g => g.id)
                const addOpenStatus = e.map((item, index) => ({
                    ...item,
                    open: groupArr.length ? groupArr[index].open : false, // 缓存分组展开状态
                }))
                resetList(addOpenStatus)
                sortGoodStore.setActiveId(e[0].id)
                if (get(e[0], 'secondary_group[0].id')) sortGoodStore.setSecondId(e[0].secondary_group[0].id)
            },
        },
    )

    return (
        <Column className={getCls()}>
            <Spin spinning={loading} className={loading ? getCls('spin') : ''}>
                <SortGroupList
                    secondGroupId={secondGroupId}
                    groupArr={groupArr}
                    onClick={index => {
                        replace(index, {
                            ...groupArr[index],
                            open: !groupArr[index].open,
                        })
                    }}
                    distance={20}
                    axis="y"
                    helperClass="paymode-sort-helper"
                    onSortEnd={({ oldIndex, newIndex }) => {
                        if (oldIndex === newIndex) return
                        move(oldIndex, newIndex)
                        ;[groupIds.current[oldIndex], groupIds.current[newIndex]] = [
                            groupIds.current[newIndex],
                            groupIds.current[oldIndex],
                        ]
                        sortGroupReq.run()
                    }}
                />
            </Spin>
        </Column>
    )
}

export default SortGoodsGroup
